import { ErrorOutline } from "@mui/icons-material";
import { Box, Button, Container, Typography } from "@mui/material";
import { Link } from "react-router-dom";

export const AuthErrorPage = () => (
	<Box
		display="flex"
		flexDirection="column"
		height="80vh"
		textAlign="center"
		justifyContent="center"
	>
		<Container maxWidth="md">
			<ErrorOutline fontSize="large" />
			<Typography align="center" variant="h1" mb={4}>
				Opps!!!
			</Typography>
			<Typography align="center" variant="h4" mb={4}>
				It seems like you don't have the magic key to unlock this content. 🧙‍♂️
				Maybe ask your admin for a power-up? 🚀
			</Typography>
			<Button
				color="primary"
				variant="contained"
				component={Link}
				to="/"
				disableElevation
			>
				Go Back to Home
			</Button>
		</Container>
	</Box>
);
